<div class="cal-month-view">
  <div class="month-header">
    <button class="nav-btn" (click)="navigateMonth(-1)">
      <ng-icon name="iconoirNavArrowLeft" size="20"></ng-icon>
    </button>
    <span class="month-title">{{ currentMonthName }} {{ currentYear }}</span>
    <button class="nav-btn" (click)="navigateMonth(1)">
      <ng-icon name="iconoirNavArrowRight" size="20"></ng-icon>
    </button>
  </div>

  <div class="cal-cell-row cal-header">
    @for (day of weekDays; track day) {
      <div class="cal-cell">{{ day }}</div>
    }
  </div>

  <div class="cal-days">
    @if (loading()) {
      @for (week of calendarWeeks(); track $index) {
        <div class="cal-cell-row">
          @for (day of week; track $index) {
            <div class="cal-cell skeleton-cell">
              <app-wiper-loading />
            </div>
          }
        </div>
      }
    } @else {
      @for (week of calendarWeeks(); track $index) {
        <div class="cal-cell-row">
          @for (day of week; track day.date.toISOString()) {
            <div
              class="cal-cell"
              [class.cal-today]="day.isToday"
              [class.other-month]="!day.isCurrentMonth"
              [class.is-marked]="day.isMarked"
              [class.selected]="day.isSelected"
              [class.clickable]="day.isCurrentMonth && day.isMarked"
              (click)="onDayClick(day)"
            >
              <span class="day-number">{{ day.day }}</span>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
